module.exports = __webpack_public_path__ + "img/passright.2f8f1db6.png";